import { useQuery } from '@tanstack/react-query';
import makeRpcRequest from '@/shared/utils/rpc';

export default function useEnvironment() {
  const rpcName = 'cf_environment' as const;

  const { isLoading, data } = useQuery({
    queryKey: [rpcName],
    queryFn: () => makeRpcRequest(rpcName),
    refetchInterval: 5_000,
    select(result) {
      return {
        ingressFees: result.ingress_egress.ingress_fees,
        egressFees: result.ingress_egress.egress_fees,
        minimumDepositAmounts: result.ingress_egress.minimum_deposit_amounts,
        boostMinimumAddFundAmounts: result.ingress_egress.boost_minimum_add_funds_amounts,
        poolFees: result.pools.fees,
      };
    },
  });

  return { isLoading, ...data };
}
